<template>
    <Header12 />
    <div class="body">
        <section class="background-clair">
            <MenuTitle title="Nos prochaines" subTitle="sessions" srcImg="/images/pages/organisme-formation.jpg"
                backgroundSpan="span-background org" />
        </section>
        <section>
            <div class="wrap" v-if="isLoading">
                <div class="spinner-wrap">
                    <div class="spinner">
                        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                    </div>
                </div>
            </div>
            <div class="container pt-70" v-if="!isLoading">
                <div class="row">
                    <div class="add-padding">
                        <form @submit.prevent="onSubmit" @reset.prevent="onReset">
                            <div class="form-group mb-2 row">
                                <div class="col-md-6 col-sm-6">
                                    <select v-model="selectedCategory" class="form-select">
                                        <option value="tous">Tous</option>
                                        <option value="softs skills">Softs Skills</option>
                                        <option value="ressources humaines et rse">Ressources Humaines et RSE</option>
                                        <option value="leadership et management">Leadership et Management</option>
                                    </select>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <input type="text" v-model="searchKeyword" placeholder="Recherche par mot-clé"
                                        class="form-control">
                                </div>
                                <div class="col-md-2 col-sm-6">
                                    <button type="reset" class="btn btn-secondary mb-2"><i
                                            class="fa-light fa-rotate-left"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <section class="section-padding">
                <div class="container pt-10 pb-120 md-pt-100 md-pb-80 justify-content-center add-padding">
                    <a v-for="(item, index) in filteredSessions" :key="index" class="row bgCard" :href="`${item.url}`"
                        target="_blank">
                        <div class="col-md-2 box-content interval" :class="`${item.bgColors}`">
                            <i class="fa-light fa-calendar me-2"></i>
                            <p>{{ item.sessionInterval }}</p>
                        </div>
                        <div class="col-md-4 box-content name" :class="`${item.bgColors}`">
                            <i class="fa-light fa-magnifying-glass me-2"></i>
                            <h4>{{ item.sessionCategorieName }}</h4>
                        </div>
                        <div class="col-md-5 box-content description" :class="`${item.bgColors}`">
                            <i class="fa-light fa-circle-info me-2"></i>
                            <p class="font-rubik" v-html="item.DescriptionSA"></p>
                        </div>
                    </a>
                </div>
            </section>
        </section>
        <section>
            <NousContacter />
        </section>
        <section>
            <Footer :dark_bg="true" />
        </section>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Header12 from '~/components/common/Headers/Header-12.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue';
import MenuTitle from "../../MenuTitle";
import axios from 'axios';

const isLoading = ref(true);
const nosSessions = ref([]);

onMounted(async () => {
    isLoading.value = true;
    try {
        const response = await axios({
            method: 'post',
            url: 'https://ws2-gbbu02.graphibox.eu/EpScheduler.ws',
            data: { pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872', pFct: 'GetSchedulersAppointments' },
        });

        const currentTime = new Date().getTime();
        const filteredData = response.data.filter(training => new Date(training.EndSA).getTime() >= currentTime);

        filteredData.sort((a, b) => new Date(a.StartSA) - new Date(b.StartSA));

        const promises = filteredData.map(async training => {

            const dateStart = new Date(training.StartSA);
            const dateEnd = new Date(training.EndSA);
            const sessionInterval = dateStart.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) + ' au ' + dateEnd.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

            const parts = training.SubjectSA.split('|');
            let sessionCategorieName = parts[0];
            if (sessionCategorieName === undefined) {
                sessionCategorieName = training.SubjectSA;
            }
            let bgColors = parts[1];
            if (bgColors === undefined) {
                bgColors = 'jaune';
            }
            let url = parts[2];
            if (url === undefined) {
                url = '#';
            }
            const DescriptionSA = training.DescriptionSA

            return {
                ...training,
                sessionInterval,
                sessionCategorieName,
                bgColors,
                url,
                DescriptionSA
            };
        });

        nosSessions.value = await Promise.all(promises);
        isLoading.value = false;
    } catch (error) {
        console.error('Erreur lors du chargement des données :', error);
        isLoading.value = false;
    }
});


const selectedCategory = ref('tous');
const searchKeyword = ref('');

const filteredSessions = computed(() => {
    const selectedCategoryLower = selectedCategory.value.toLowerCase().trim();
    const searchKeywordLower = searchKeyword.value.toLowerCase().trim();

    return nosSessions.value.filter(session =>
        (session.sessionCategorieName.toLowerCase().trim() === selectedCategoryLower || selectedCategoryLower === 'tous')
        && (session.DescriptionSA.toLowerCase().includes(searchKeywordLower)
            || session.SubjectSA.toLowerCase().includes(searchKeywordLower)
            || session.sessionInterval.toLowerCase().includes(searchKeywordLower)
        )
    );
});

const onReset = () => {
    selectedCategory.value = 'tous';
    searchKeyword.value = '';
};
</script>

<style scoped>
.body {
    overflow: hidden !important;
    margin-top: 120px;
}

.section-padding {
    padding: 2rem 14.5vw
}

.form-group {
    width: 50%;
}

.btn-secondary {
    background-color: var(--bleu-fonce);
    ;
}


a {
    padding: 0px 170px;
}

.bgCard {
    padding: 5px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    border: 0.2px solid var(--zinc-100, #EEF5FA);
    background: var(--zinc-0, #FFF);
}

.bgCard:hover {
    transform: translateY(-5px);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
}

.box-content {
    background: white;
    margin: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 20px;
    border-radius: 0.5625rem;
    color: #FFF;
}

.box-content i {
    color: #000;
}




.blue,
.rouge,
.jaune {
    color: #FFF;
}

.jaune {
    background: #FFD186;
}

.blue {
    background: #D2EEFF;
}

.rouge {
    background: #F9E1E2;
}

.breadcrumb a {
    padding: 0px;
}

@media screen and (max-width: 320px) {
    .section-padding {
        padding: 2rem 1.5vw;
    }

    .box-content {
        margin: 0.172345rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 375px) {
    .section-padding {
        padding: 2rem 1.5vw;
    }

    .box-content {
        margin: 0.172345rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 425px) {
    .section-padding {
        padding: 2rem 1.5vw;
    }

    .box-content {
        margin: 0.172345rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 768px) {
    .section-padding {
        padding: 2rem 1.5vw;
    }

    .box-content {
        margin: 0.272345rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 1024px) {
    .section-padding {
        padding: 1rem 10.5vw;
    }

    .box-content {
        margin: 0.572345rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 1440px) {
    .section-padding {
        padding: 1rem 15.5vw;
    }

    .box-content {
        margin: 0.12rem;
    }

    .container {
        padding-top: unset !important;
        padding-bottom: unset !important;
    }
}

@media screen and (max-width: 2559px) {}
</style>